import React, { useCallback, useContext, useMemo } from 'react';
import { ChatbotDataContext } from '../../context/ChatbotDataContext';
import { Box, Button, Flex, Text } from 'pcln-design-system';
import { ChatBubble as ChatIcon } from 'pcln-icons';
import { useGoogleMapsHooks } from './useGoogleMapsHooks';
import { useChatUIContext } from '../../hooks/useChatUIContext';
import styled from 'styled-components';
const RelativeBox = /*#__PURE__*/styled(Box).withConfig({
  displayName: "GoogleMapComponents__RelativeBox",
  componentId: "sc-ywbqkz-0"
})(["position:relative;z-index:1000;"]);
const CloseMapButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "GoogleMapComponents__CloseMapButton",
  componentId: "sc-ywbqkz-1"
})(["position:absolute;top:16px;right:16px;"]);
/**
 * GoogleMapComponents - Google map components
 * @internal
 */
const GoogleMapComponents = React.memo(({
  mapContainerStyle = {
    height: 'calc(100% - 60px)',
    width: '100%'
  },
  buttonStyle = {
    position: 'absolute',
    bottom: '0',
    left: '50%',
    transform: 'translate(-50%, -15px)'
  }
}) => {
  const {
    hotelOnMapList,
    locationPinList
  } = useContext(ChatbotDataContext);
  const {
    setIsMapOpened,
    isMapOpened,
    shouldDisplayMapButton
  } = useChatUIContext();
  const hotelPinsOnMap = useMemo(() => {
    return hotelOnMapList === null || hotelOnMapList === void 0 ? void 0 : hotelOnMapList.reduce((acc, curr) => {
      var _a;
      if (((_a = curr === null || curr === void 0 ? void 0 : curr.hotel) === null || _a === void 0 ? void 0 : _a.hotelType) !== 'SOPQ') {
        acc[curr.name] = Object.assign({}, curr);
      }
      return acc;
    }, {});
  }, [hotelOnMapList]);
  const locationPinsOnMap = useMemo(() => {
    const removeDuplicates = locationPinList.filter(pin => {
      if (pin === null || pin === void 0 ? void 0 : pin.hotelId) {
        const hasDuplicatePin = hotelOnMapList.some(hotel => {
          var _a;
          return ((_a = hotel === null || hotel === void 0 ? void 0 : hotel.hotel) === null || _a === void 0 ? void 0 : _a.hotelId) === pin.hotelId;
        });
        return !hasDuplicatePin;
      }
      return true;
    });
    return removeDuplicates === null || removeDuplicates === void 0 ? void 0 : removeDuplicates.reduce((acc, curr) => {
      acc[curr.name] = Object.assign({}, curr);
      return acc;
    }, {});
  }, [locationPinList]);
  useGoogleMapsHooks({
    hotelPinsOnMap,
    locationPinsOnMap
  });
  const handleOnClick = useCallback(function handleOnClick(event) {
    event.preventDefault();
    event.stopPropagation();
    setIsMapOpened(false);
  }, [setIsMapOpened]);
  return React.createElement(React.Fragment, null, isMapOpened && shouldDisplayMapButton && React.createElement(RelativeBox, null, React.createElement(CloseMapButton, {
    title: 'Close Map',
    variation: 'white',
    color: 'primary',
    size: 'small',
    onClick: handleOnClick
  }, "Close Map")), React.createElement("div", {
    style: mapContainerStyle,
    id: 'PENNY-SEARCH-GOOGLE-MAP'
  }), shouldDisplayMapButton && React.createElement(Button, {
    size: 'small',
    style: buttonStyle,
    onClick: handleOnClick,
    title: 'Close Map'
  }, React.createElement(Flex, null, React.createElement(ChatIcon, {
    color: 'lightest',
    size: 16
  }), React.createElement(Text, {
    ml: 1
  }, "Chat"))));
});
export default GoogleMapComponents;